import React, { useState, useEffect } from 'react'
import moment from 'moment'

import { getEvent, deleteEvent } from '../Context/firebase'
import { Link, useParams } from 'react-router-dom'

// Components
import { TimelinePhase, Summary, DeleteModal } from '../Components/MyEvent/EventComponents'
import ActivityPreview from '../Components/ActivityPreview'
import { FlexboxGrid, ButtonToolbar, IconButton, Divider, Checkbox, Timeline, Icon, Loader, Drawer } from 'rsuite'
import { H1, Title, InlineFlex, FlexWrapper, StartButton, Back } from '../Components/MyEvent/MyEventStyledComponents'
import { Bin, Edit } from '../Components/Icons'

// Styles
import styled from 'styled-components'
import { colors, fonts } from '../Components/Styles/common-styles'
import '../Components/Styles/event.css'

const MyDrawer = styled(Drawer)`
  -webkit-animation: slide-in 0.7s forwards;
  .rs-drawer-content {
    overflow: auto;
  },
`

const DateText = styled.div`
  margin: 5% 0;
  font-size: ${fonts.normalSize};
  font-weight: 600;
  line-height: 140%;
  min-width:50%;
  color: ${colors.black};
`

const GoalList = styled.li`
    font-size:${fonts.normalSize}
    ::before, ::marker {
    content: '...'!important;
    line-height: 140%;
    padding:5px;
}
`
const GoalTitle = styled.div`
    font-size:${fonts.largeSize};
    padding: 5px;
    list-style: none;
    left: 0px;
    font-weight: 600;
}
`
export default function EventDecription () {
  const { eventId } = useParams()
  const [showModal, setModalShown] = useState(false)
  const [eventData, setEvent] = useState()
  const [error, setError] = useState()
  const [showActivityPreviewModal, setActivityPreviewModal] = useState(false)
  const [activityId, setActivityId] = useState(null)
  const [selectedPhaseIndex, setSelectedPhaseIndex] = useState(0)

  useEffect(() => {
    getEvent(eventId).then(data => {
      setEvent(data)
    }).catch(err => {
      setError('Event not found')
      console.log(err)
    })
  }, [])

  const prepArray = []
  const toolsArray = []
  if (eventData) {
    eventData.phases.forEach(phase => {
      phase.data.forEach(activity => {
        activity?.preparation.forEach(prep => {
          prepArray.push(prep.text)
        })
        activity?.requisites.forEach(tools => {
          toolsArray.push(tools.text)
        })
      })
    })
  }

  const getActivity = (id) => {
    if (id) {
      let data = {}
      eventData.phases.map(activity => {
        if (activity) {
          activity.data.find(item => {
            if (item.id === id) {
              data = item
            }
          })
        }
      })
      return { data: data }
    }
  }
  const showDeleteModal = () => { setModalShown(true) }
  const hideDeleteModal = () => { setModalShown(false) }
  console.log(selectedPhaseIndex)
  // Function to delete event permanently
  async function handleDelete (props) {
    const eventId = props.target.value
    try {
      console.log('try to delete' + eventId)
      await deleteEvent(eventId)
      setModalShown(false)
      window.location.href = '/events/'
    } catch (error) {
      console.error(error)
      return setError('Unable to Delete')
    }
    setError('')
  }
  return (
    <FlexboxGrid justify='center' align='middle' style={{ margin: '26px 20px 20px 28px' }}>
      <FlexboxGrid.Item colspan={24} style={{ marginBottom: '2%' }}>
        <Link to='/events' style={{ width: '200px' }} colSpan={24}> <Back padded colored> &#8592; Back to all activities</Back> </Link>
        {error && <div>{error}</div>}
      </FlexboxGrid.Item>
      {eventData
        ? (
          <>
            <FlexboxGrid.Item colspan={24}>
              <MyDrawer
                size='lg'
                show={showActivityPreviewModal}
                onHide={() => setActivityPreviewModal(false)}
              >
                <ActivityPreview
                  data={getActivity(activityId)}
                  setActivityPreviewModal={setActivityPreviewModal}
                  withoutEditing
                />
              </MyDrawer>
              <DeleteModal
                show={showModal}
                handleClose={hideDeleteModal}
                title={eventData.title} id={eventData.id}
                onDelete={(eventId) => handleDelete}
                msg='Event' />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={24}>
              <InlineFlex style={{ width: '100%' }}>
                <H1 style={{ width: '100%' }}>{eventData.title}</H1>
                <ButtonToolbar style={{ width: '300px' }}>
                  <IconButton className='i-button' onClick={e => { window.location.href = `/events/${eventData.id}/edit` }} icon={<Edit stroke={colors.grey} />} />
                  <IconButton className='i-button' onClick={showDeleteModal} icon={<Bin stroke={colors.grey} />} />
                  <StartButton onClick={e => { window.location.href = `/events/${eventId}` }}>Start</StartButton>
                </ButtonToolbar>
              </InlineFlex>
            </FlexboxGrid.Item>
            <InlineFlex style={{ width: '100%' }} className='scroll'>
              <FlexboxGrid.Item colspan={8}>
                <DateBlock {...eventData} />
                <FlexWrapper style={{ margin: '5% auto' }}>
                  {!eventData ? <Loader /> : <Summary {...eventData} />}
                </FlexWrapper>
                <Divider />
                <FlexWrapper>
                  <Title>Preparation:</Title>
                  {!prepArray ? <loader /> : <PreparationList toolsData={prepArray} />}
                </FlexWrapper>
                <FlexWrapper>
                  <Title>Tools:</Title>
                  {!toolsArray ? <loader /> : <ToolsList toolsData={toolsArray} />}
                </FlexWrapper>
                <FlexWrapper>
                  <Title>Goals:</Title>
                  <div>
                    {!eventData.goalsArray
                      ? eventData.goals.map((event, i) => <GoalList className='goal' key={i}>{event}</GoalList>)
                      : <GoalsList event={eventData.goalsArray} />}                  </div>
                </FlexWrapper>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item colspan={16}>
                <Timeline className='customTimeline'>
                  <FlexWrapper style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                    {eventData.phases.map((phase, i) =>
                      <TimelinePhase
                        setActivityPreviewModal={setActivityPreviewModal}
                        setSelectedPhaseIndex={setSelectedPhaseIndex}
                        setActivityId={setActivityId}
                        phase={phase}
                        index={i}
                        key={i}
                      />)}
                    <Timeline.Item dot={<Icon className='customDot' icon='' />} />
                  </FlexWrapper>
                  <Timeline.Item dot={<Icon className='customDot' icon='' />} />
                </Timeline>
              </FlexboxGrid.Item>
            </InlineFlex>
          </>
        )
        : null}
    </FlexboxGrid>
  )
}

const DateBlock = (props) => {
  return (
    <InlineFlex style={{ width: '300px', flexWrap: 'wrap' }}>
      <DateText colSpan={24} md={6}>Date:</DateText> <DateText colSpan={24} md={6}>{moment(props.date).format('DD MMM YYYY')}</DateText>
      <br />
      <DateText colSpan={12}>Starts at: </DateText> <DateText colSpan={12}>{moment(props.date).format('HH:mm')}</DateText>
    </InlineFlex>
  )
}
// component for goals and preperations
// TODO get all activity data and display all goals and preparations together
const ToolsList = ({ toolsData }) => {
  return (
    <>
      {!toolsData ? <Loader />
        : toolsData.map(
          (item, index) => (
            <Checkbox key={index}>{item}</Checkbox>
          )
        )}
    </>
  )
}

const PreparationList = ({ toolsData }) => {
  return (
    <>
      {!toolsData ? <Loader /> : toolsData.map(
        (item, index) => (
          <Checkbox key={index}>{item}</Checkbox>
        )
      )}
    </>
  )
}

const GoalsList = ({ event }) => {
  const array = []
  event.map((item) => array.push(item.title))
  const titles = Array.from(new Set(array))
  return (
    <>
      {titles.map((item, i) => {
        return (
          <div key={i}>
            <GoalTitle key={i}>{item}</GoalTitle>
            {event.map((event, index) => {
              if (event.title.includes(item)) {
                return (
                  <GoalList className='goal' key={index}>{event.goals}</GoalList>
                )
              }
            })}
          </div>
        )
      })}
    </>
  )
}
